export default {
  title: '职位模板管理',
  menu: '职位模板管理',
  label: {
    companyName: '公司',
    cnTemplateName: '职位中文名称',
    enTemplateName: '职位英文名称',
    enabledTemplate: '激活的模板',
    disabledTemplate: '禁用的模板',
    status: '状态'
  },
  placeholder: {
    keywords: '按照职位模板名称搜索'
  },
  btn: {
    add: '添加模板'
  },
  message: {
    confirmEnable: {
      disable: '确定要禁用这个职位模板？',
      enable: '确定要激活这个职位模板？'
    }
  }
}
